import { render, staticRenderFns } from "./DragBox.vue?vue&type=template&id=137a1135&"
import script from "./DragBox.vue?vue&type=script&lang=js&"
export * from "./DragBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports